import React, { FC, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Option } from 'react-dropdown';
import { useSelector } from 'react-redux';
import { WebAppState } from 'web/state/store.web';
import { localized } from 'shared/state/i18n/i18n';
import PageContainer from 'web/view/components/page-container/page-container';
import { SkioldDropdown } from 'web/view/components/skiold-components/skiold-dropdown/skiold-dropdown';
import { ViewWeb } from 'web/view/components/utils/web-view';
import './admin-site-migration.scss';
import { SiteMigrationOverview } from './site-migration-overview';
import { SiteArchiveOverview } from './site-archive-overview';
import { SkioldIconSpinner } from 'web/view/components/utils/skiold-icon-spinner';
import { CurrentSitesToArchive } from './current-site-to-archive';
export class ActionButton {
	public title: string | undefined;
	public action: (() => void) | undefined;
	public icon: string | undefined;
	public isLoading: boolean | undefined;
}

interface AdminSiteContextProps {
	setActionButtons: React.Dispatch<React.SetStateAction<ActionButton[]>>;
}

export const AdminSiteContext = React.createContext({} as any);
export const useAdminSite = () => useContext<AdminSiteContextProps>(AdminSiteContext);

export const AdminSiteProvider: FC = React.memo(() => {
	const [selectedOption, setSelectedOption] = useState<Option | undefined>({
		label: localized('SiteMigrationOverview'),
		value: 'SiteMigrationOverview',
	});

	const [actionButtons, setActionButtons] = useState<ActionButton[]>([]);
	const siteMigrationEnabled = useSelector((state: WebAppState) => state.featureFlags.siteMigration);

	// Get relevant pyfs
	useEffect(() => {}, []);

	const selectionChanged = useCallback((selected: Option) => {
		setActionButtons([]);
		setSelectedOption(selected);
	}, []);

	const options = useMemo(
		() => [
			{
				label: localized('SiteMigrationOverview'),
				value: 'SiteMigrationOverview',
			},
			{ label: localized('SiteArchiveOverview'), value: 'SiteArchiveOverview' },
			{ label: localized('CurrentSitesToArchive'), value: 'CurrentSitesToArchive' },
		],
		[],
	);

	if (!siteMigrationEnabled) {
		return null;
	}

	return (
		<AdminSiteContext.Provider value={{ setActionButtons }}>
			<PageContainer>
				<ViewWeb className="admin-site-top-container">
					<SkioldDropdown items={options} selectedValue={selectedOption} onValueChanged={selectionChanged} />
					<ViewWeb className="absolute-align-right flex-row">
						{actionButtons.map((button, index) => (
							<React.Fragment key={index}>
								{index > 0 && <ViewWeb className="borderButtonsView" />}

								<SkioldIconSpinner
									title={button.title}
									icon={button.icon}
									onPress={button.action}
									showSpinnerControlled={button.isLoading}
									clipSize={45}
								/>
							</React.Fragment>
						))}
					</ViewWeb>
				</ViewWeb>
				<ViewWeb className="align-items-center">
					{selectedOption?.value === 'SiteMigrationOverview' && <SiteMigrationOverview />}
					{selectedOption?.value === 'CurrentSitesToArchive' && <CurrentSitesToArchive />}
					{selectedOption?.value === 'SiteArchiveOverview' && <SiteArchiveOverview />}
				</ViewWeb>
			</PageContainer>
		</AdminSiteContext.Provider>
	);
});
